const TASK_URL_REGEX = /\b((?:https?:\/\/|www\.)[^\s<]+)/gi;
const TRAILING_PUNCTUATION_REGEX = /[),.;!?]/;

function splitTrailingPunctuation(rawMatch) {
  let url = rawMatch;
  let trailing = '';

  while (url.length > 0 && TRAILING_PUNCTUATION_REGEX.test(url[url.length - 1])) {
    trailing = `${url[url.length - 1]}${trailing}`;
    url = url.slice(0, -1);
  }

  return { url, trailing };
}

function getUrlHref(url) {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  return `https://${url}`;
}

function pushTextSegment(segments, value) {
  if (!value) return;

  const previous = segments[segments.length - 1];
  if (previous && previous.type === 'text') {
    previous.value = `${previous.value}${value}`;
    return;
  }

  segments.push({
    type: 'text',
    value,
  });
}

export function linkifyTaskText(text) {
  if (typeof text !== 'string' || text.length === 0) {
    return [{ type: 'text', value: '' }];
  }

  const segments = [];
  let cursor = 0;
  let match;

  while ((match = TASK_URL_REGEX.exec(text)) !== null) {
    const matchText = match[0];
    const matchStart = match.index;
    const matchEnd = matchStart + matchText.length;

    if (matchStart > cursor) {
      pushTextSegment(segments, text.slice(cursor, matchStart));
    }

    const { url, trailing } = splitTrailingPunctuation(matchText);

    if (url.length > 0) {
      segments.push({
        type: 'link',
        value: url,
        href: getUrlHref(url),
      });
    }

    if (trailing.length > 0) {
      pushTextSegment(segments, trailing);
    }

    cursor = matchEnd;
  }

  if (cursor < text.length) {
    pushTextSegment(segments, text.slice(cursor));
  }

  return segments.length > 0 ? segments : [{ type: 'text', value: text }];
}
